import { Flex, Tag } from '@chakra-ui/react';
import { tagStyle } from 'shared/styles';

const TagsCell = ({ getValue }: { getValue: () => string[] }) => {
    const tagList = getValue().map((tagName: string) => (
        <Tag {...tagStyle} mb={2} mr={2} key={tagName}>
            {tagName}
        </Tag>
    ));

    return (
        <Flex width="100%" flexWrap="wrap">
            {tagList}
        </Flex>
    );
};

export default TagsCell;
